import { useQuery } from "@tanstack/react-query";
import { getHighlyConfidentialFileContent } from "../api";

/**
 * 高機密ファイル内容を取得
 */
export const useHighlyConfidentialFileContent = (
  s3Url: string,
  originalName: string,
  mimeType: string,
  options: {
    enabled?: boolean;
  } = {},
) => {
  return useQuery({
    queryKey: [
      "highly-confidential-file-content",
      s3Url,
      originalName,
      mimeType,
    ],
    queryFn: () =>
      getHighlyConfidentialFileContent(s3Url, originalName, mimeType),
    enabled: options.enabled && !!s3Url && !!originalName && !!mimeType,
    staleTime: 0, // ファイルは常に最新を取得
    gcTime: 0, // Blob URL はキャッシュしない
    retry: false, // ファイル取得失敗時は再試行しない
  });
};
